module.exports = __webpack_public_path__ + "static/example_month_rows-f35c95b90033b2b9fdb9962b4b37677f.png";